import React, {
	ReactElement,
	useMemo,
	useState,
	createContext,
	useEffect,
} from 'react';
import { getLocation } from '../lib/REST/utils';

function getPreview(rcxpv = '') {
	return rcxpv ? { rcxpv } : {};
}

function getQueryParam(location: string = '', paramKey: string = '') {
	try {
		const url = new URL(location);
		const params = new URLSearchParams(url.search);
		return params.get(paramKey);
	} catch (e) {
		return null;
	}
}

function getPreviewParamFromURl(defaultData = '') {
	const rcxpv = getQueryParam(getLocation(), 'rcxpv');
	return rcxpv || defaultData;
}

export const PreviewContext = createContext<object>({});

export function PreviewProvider({
	children,
	defaultData = '',
}: {
	children: ReactElement;
	defaultData?: string;
}) {
	const [preview, setPreview] = useState<string>(
		getPreviewParamFromURl(defaultData)
	);
	const previewQuery = useMemo(() => getPreview(preview), [preview]);

	useEffect(() => {
		const previewParam = getPreviewParamFromURl(defaultData);
		return setPreview(previewParam);
	}, [defaultData]);

	return (
		<PreviewContext.Provider value={previewQuery}>
			{children}
		</PreviewContext.Provider>
	);
}
